module.exports = __webpack_public_path__ + "static/media/career.c9165222.jpg";